import { useThemeContext } from "@freightsimple/ui-core/Theme/useThemeContext";
import { nextTheme } from "@freightsimple/ui-core/Theme/useTheme";
import { DevValueRow, type DevMenuTone } from "./DevMenuPrimitives";

const labels = {
  light: "Light",
  dark: "Dark",
  system: "System",
} as const;

interface ThemeMenuItemProps {
  indented?: boolean | undefined;
  tone?: DevMenuTone | undefined;
}

/**
 * Cycles through Light → Dark → System on click. Wires through `<ThemeProvider>`
 * so the localStorage write and DOM `data-theme` attribute are kept in sync.
 */
export function ThemeMenuItem({ indented, tone }: ThemeMenuItemProps) {
  const { theme, setTheme } = useThemeContext();
  return (
    <DevValueRow
      label="Theme"
      value={labels[theme]}
      onClick={() => setTheme(nextTheme(theme))}
      indented={indented}
      tone={tone}
    />
  );
}
